import { useState } from 'react'
import { Media } from '@/components/Media'
import type { NavContent } from '@/lib/content.types'

export function Nav({ data }: { data: NavContent }) {
  const [open, setOpen] = useState(false)

  return (
    <nav className="sticky top-0 z-50 border-b border-line-hairline bg-surface-base/70 backdrop-blur-[14px]">
      <div className="mx-auto flex h-[66px] max-w-content items-center justify-between px-5 md:px-10">
        <a href="#top" className="flex items-center gap-[11px]" aria-label={data.logo.alt}>
          <Media
            media={data.logo}
            loading="eager"
            className="h-[26px] w-auto object-contain"
          />
        </a>

        {/* 데스크톱 링크 */}
        <div className="hidden items-center gap-[34px] md:flex">
          {data.links.map((link) => (
            <a
              key={link.href + link.label}
              href={link.href}
              className="text-sm font-medium text-ink-secondary transition-colors hover:text-ink-primary"
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* 모바일 햄버거 */}
        <button
          type="button"
          className="flex h-9 w-9 items-center justify-center rounded-lg border border-line-button md:hidden"
          aria-expanded={open}
          aria-controls="annx-mobile-nav"
          aria-label={open ? 'Close menu' : 'Open menu'}
          onClick={() => setOpen((v) => !v)}
        >
          <span className="relative block h-[10px] w-4">
            <span
              className={`absolute left-0 block h-[1.5px] w-4 bg-ink-secondary transition-transform ${
                open ? 'top-[4px] rotate-45' : 'top-0'
              }`}
            />
            <span
              className={`absolute left-0 block h-[1.5px] w-4 bg-ink-secondary transition-transform ${
                open ? 'top-[4px] -rotate-45' : 'top-[8px]'
              }`}
            />
          </span>
        </button>
      </div>

      {open && (
        <div
          id="annx-mobile-nav"
          className="border-t border-line-hairline bg-surface-base px-5 pb-4 pt-2 md:hidden"
        >
          {data.links.map((link) => (
            <a
              key={link.href + link.label}
              href={link.href}
              onClick={() => setOpen(false)}
              className="block py-3 text-[15px] font-medium text-ink-secondary transition-colors hover:text-ink-primary"
            >
              {link.label}
            </a>
          ))}
        </div>
      )}
    </nav>
  )
}
